import { useState, useEffect } from "react";

/**
 * @param {{
 *  id: string;
 *  cdSeconds: number;
 * }} param
 */
export const useFnCallInterval = ({ id, cdSeconds }) => {
  const [cd, setCd] = useState(0);

  useEffect(() => {
    const savedUntil = localStorage.getItem(id);
    if (savedUntil) {
      const diff = Math.floor((+savedUntil - Date.now()) / 1000);
      if (diff > 0) {
        setCd(diff);
      } else {
        localStorage.removeItem(id);
      }
    }
  }, []);

  useEffect(() => {
    if (cd > 0) {
      const timer = setInterval(() => {
        setCd((prev) => {
          if (prev <= 1) {
            localStorage.removeItem(id);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [cd]);

  const after_ = () => {
    const until = Date.now() + cdSeconds * 1000;
    localStorage.setItem(id, String(until));
    setCd(cdSeconds);
  };

  const callAsync = async (fn) => {
    await fn();
    after_();
  };

  const call = (fn) => {
    fn();
    after_();
  };

  return {
    cd,
    call,
    callAsync,
  };
};
